import React, { useState } from 'react';
import { cloneDeep } from 'lodash';
import logo from '../../images/zaddons_logo.png'
import AdminSettings from '../../../AdminSettings';
import ManagerPortal from '../../../ManagerPortal';
import EmployeeDashboard from '../../../EmploymentBillboard/App/EmployeeDashboard/index';
import DashboardLayout from '../Layout/Dashboard';
import LoginForm from './LoginForm';
import NotFound from '../NotFound';
import './Login.scss';
import AuthService, { Toast } from '../../../services/auth';
import urlHelper from '../../utilities/urlHelper.js';

const styles = {
    centering: {
        textAlign: '-webkit-center',
        margin: '30px',
    },
    card: {
        maxWidth: 345,
        height: 360,
        margin: '0 auto'
    },
    media: {
        width: '210px',
        margin: '7px',
        height: '50px'
    },
    BackCardMedia: {
        background: '#1a508a',
        width: 'auto',
        height: '70px',
        padding: '3px',
    },
    buttonSubmit: {
        color: 'white',
        background: '#1a508a',
        marginTop: '35px',
        '&:hover': {
            backgroundColor: '#1864b5',
            borderColor: '#1864b5'
        }
    },
    icons: {
        float: 'right'
    }
};

const hasQueryStringParams = window.location.href.indexOf('?') !== -1;
const appTargetFromSession = sessionStorage.getItem('appTarget');
const target = hasQueryStringParams
    ? urlHelper.getQueryStringParam(window.location.href, 'target')
    : appTargetFromSession;

const ssoToken = hasQueryStringParams
    ? urlHelper.getQueryStringParam(window.location.href, 'ssoToken')
    : undefined;

const ADMIN_SETTINGS = 'adminSettings';
const MANAGER_PORTAL = 'managerPortal';
const EMPLOYMENT_BILLBOARD = 'employmentBillboard';
const EMPLOYMENTBILLBOARD_APPLICATIONS = [ADMIN_SETTINGS, MANAGER_PORTAL, EMPLOYMENT_BILLBOARD];

/**
 * @param {{ password: string; username: string; }} param0
 * @returns {boolean} `true` when no error messages in the login form
 */
export const validateFormLogin = ({ password, username }) => {
    var errorMessage = '';

    if (!password.trim()) {
        errorMessage = 'Password is required';
    }

    if (!username.trim()) {
        errorMessage = 'Username is required';
    }

    if (errorMessage) {
        Toast.fire({
            icon: 'error',
            title: errorMessage,
            timer: 3000
        });
    }

    return !errorMessage;
};

const emptyAccount = {
    username: "",
    password: "",
};

const Login = ({ children }) => {
    const [account, setAccount] = useState({ ...emptyAccount });

    const handleChange = ({ currentTarget: { name, value } }) => {
        const updatedAccount = cloneDeep(account);
        updatedAccount[name] = value;
        setAccount(updatedAccount);
    }

    const handleSubmitLogin = (event) => {
        event.preventDefault();

        if (validateFormLogin(account)) {
            AuthService.login(account.username, account.password, target)
                .then(success => {
                    if (success) {
                        window.history.replaceState({}, '', `${window.location.pathname}`);
                        setAccount({ ...emptyAccount });
                    }
                });
        }
    }

    if (!EMPLOYMENTBILLBOARD_APPLICATIONS.includes(target)) {
        return <NotFound />;
    }

    if (!AuthService.isLoggedIn()) {
        if (!ssoToken) {
            return (
                <>
                    <LoginForm
                        account={account}
                        children={children}
                        logo={logo}
                        handleChange={handleChange}
                        handleSubmitLogin={handleSubmitLogin}
                    />
                </>
            );
        }

        AuthService.ssoLogin(ssoToken, target)
            .then(success => {
                if (success) {
                    window.history.replaceState({}, '', `${window.location.pathname}`);
                    setAccount({ ...emptyAccount });
                }
            });
        return <></>;
    }

    switch (target) {
        case ADMIN_SETTINGS:
            return (
                <DashboardLayout>
                    <AdminSettings />
                </DashboardLayout>
            );
        case MANAGER_PORTAL:
            return (
                <DashboardLayout position={'relative'}>
                    <ManagerPortal />
                </DashboardLayout>
            );
        case EMPLOYMENT_BILLBOARD:
            return (
                <DashboardLayout hideScrollbar>
                    <EmployeeDashboard />
                </DashboardLayout>
            );
        default:
            return <NotFound />;
    }
}
export default Login;